import { UserCircleIcon, DocumentIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import Topbar from './Topbar'
import Footer from './Footer'
import { useState } from 'react'
import { Field, Label, Switch } from '@headlessui/react'


export default function IdeaRegistration() {
  const [is_provisional, setProvisional] = useState(false)
  const [addToEmailList, setAddToEmailList] = useState(true)

  function handleSubmitIdeaRegistration(event) {
    event.preventDefault()
    const data = new FormData(event.target)
    const ideaname = data.get('ideaname')
    const summary = data.get('summary')
    const help = data.get('help')
    const linkedin_profile = data.get('linkedin_profile')
    const github_profile = data.get('github_profile')
    const patent_number = data.get('patent_number')
    const first_name = data.get('first_name')
    const last_name = data.get('last_name')
    const phone = data.get('phone')
    const email = data.get('email')
    const country = data.get('country')
    const street_address = data.get('street_address')
    const city = data.get('city')
    const state = data.get('state')
    const postal_code = data.get('postal_code')
    const contact_method = data.get('contact_method')
    const file_upload = data.get('file_upload')
    const is_provisional = data.get('is_provisional')
  
    fetch('/idea_registration', {
      method: 'POST',
      headers: {        
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        ideaname: ideaname,
        summary: summary,
        help: help,
        linkedin_profile: linkedin_profile,
        github_profile: github_profile,
        patent_number: patent_number,
        first_name: first_name,
        last_name: last_name,
        phone: phone,
        email: email,
        country: country,
        street_address: street_address,
        city: city,
        state: state,
        postal_code: postal_code,
        contact_method: contact_method,
        file_upload: file_upload,
        is_provisional: is_provisional,
      }),
    })
    .then((data) => {
      console.log('Success:', data)
      window.location.href = '/inputcode/idea_registration'
    })
    .catch((error) => {
      console.error('Error:', error)
    })
  }
  

  return (
    <div>
        <Topbar />
    <form onSubmit={handleSubmitIdeaRegistration} method="POST">
      <div className="bg-white px-10 py-16 sm:py-20">
        <h1 className="text-2xl font-semibold text-gray-900">Register your idea</h1>
        <div>
          <p className="max-w-2xl text-sm/6 text-gray-600">
            Have a software project your working on?  Need a way to increase velocity?
            Have a great idea but no technical founder to help you build it?  We can help. 
            While we cannot accept every idea we will review your submission and get back to you.
            Need help? Schedule time to <a href="https://calendly.com/ryan-binaryinventions" target="_blank" rel="noreferrer" className="font-bold text-blue-500">talk first</a>
          </p>

          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="ideaname" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Give your idea a name
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:max-w-md">
                  <input
                    id="ideaname"
                    name="ideaname"
                    type="text"
                    placeholder=""
                    className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                  />
                </div>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="summary" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Summarize your idea
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <textarea
                  id="summary"
                  name="summary"
                  rows={3}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-2xl sm:text-sm/6"
                  defaultValue={''}
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="cover-photo" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Upload an abstract describing your idea.  Download the template and instructions <a href="/abstract_template.docx" className="font-bold text-blue-500">here</a> 
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <div className="flex max-w-2xl justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                  <div className="text-center">
                    <DocumentIcon aria-hidden="true" className="mx-auto size-12 text-gray-300" />
                    <div className="mt-4 flex text-sm/6 text-gray-600">
                      <label
                        htmlFor="file_upload"
                        className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                      >
                        <span>Upload a file</span>
                        <input id="file_upload" name="file_upload" type="file" className="sr-only" />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs/5 text-gray-600">1 page pdf or docx</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="help" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Do you need help implementing this idea?
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <textarea
                  id="help"
                  name="help"
                  rows={3}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-2xl sm:text-sm/6"
                  defaultValue={''}
                />
              </div>
            </div>

          </div>
        </div>

        <div>
        <h2 className="text-base/7 font-semibold text-gray-900">External References</h2>
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="linkedin_profile" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                LinkedIn
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="linkedin_profile"
                  name="linkedin_profile"
                  type="text"
                  autoComplete=""
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="github_profile" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                github
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="github_profile"
                  name="github_profile"
                  type="text"
                  autoComplete=""
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="patent_number" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Patent Number
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="patent_number"
                  name="patent_number"
                  type="text"
                  autoComplete=""
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
                <Field className="flex gap-x-4 sm:col-span-2">
                  <div className="flex h-6 items-center">
                    <Switch
                      checked={is_provisional}
                      onChange={setProvisional}
                      className="group flex w-8 flex-none cursor-pointer rounded-full bg-gray-200 p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 data-[checked]:bg-gray-600"
                    >
                      <span className="sr-only">Provisional</span>
                      <span
                        aria-hidden="true"
                        className="size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out group-data-[checked]:translate-x-3.5"
                      />
                    </Switch>
                  </div>
                  <Label className="text-sm/6 text-gray-600">
                    Is this a provisional or pending patent? 
                  </Label>
                </Field>
              </div>    
          </div>
        
        </div>

        <div>
          <h2 className="py-6 text-base/7 font-semibold text-gray-900">Personal Information</h2>
          <p className="mt-1 max-w-2xl text-sm/6 text-gray-600">Use a permanent address where you can receive mail.</p>

          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
          <div className="sm:grid sm:grid-cols-3 sm:items-center sm:gap-4 sm:py-6">
              <label htmlFor="photo" className="block text-sm/6 font-medium text-gray-900">
                Photo
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <div className="flex items-center gap-x-3">
                  <UserCircleIcon aria-hidden="true" className="size-12 text-gray-300" />
                  <button
                    type="button"
                    className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Change
                  </button>
                </div>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="first_name" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                First name
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="first_name"
                  name="first_name"
                  type="text"
                  autoComplete="given-name"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="last_name" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Last name
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="last_name"
                  name="last_name"
                  type="text"
                  autoComplete="family-name"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Email address
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-md sm:text-sm/6"
                />
                <Field className="flex gap-x-4 sm:col-span-2">
                  <div className="flex h-6 items-center">
                    <Switch
                      name="add-to-email-list"
                      checked={addToEmailList}
                      onChange={setAddToEmailList}
                      className="group flex w-8 flex-none cursor-pointer rounded-full bg-gray-200 p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 data-[checked]:bg-gray-600"
                    >
                      <span className="sr-only">Join our email list.</span>
                      <span
                        aria-hidden="true"
                        className="size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out group-data-[checked]:translate-x-3.5"
                      />
                    </Switch>
                  </div>
                  <Label className="text-sm/6 text-gray-600">
                    Selected automatically joins our email list!
                  </Label>
                </Field>                
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="phone" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Phone
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="phone"
                  name="phone"
                  type="phone"
                  autoComplete="phone"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-md sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="country" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Country
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <div className="grid grid-cols-1 sm:max-w-xs">
                  <select
                    id="country"
                    name="country"
                    autoComplete="country-name"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  >
                    <option>United States</option>
                    <option>Canada</option>
                    <option>Mexico</option>
                  </select>
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                  />
                </div>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="street-address" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                Street address
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="street-address"
                  name="street-address"
                  type="text"
                  autoComplete="street-address"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xl sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="city" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                City
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="city"
                  name="city"
                  type="text"
                  autoComplete="address-level2"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="state" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                State / Province
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="state"
                  name="state"
                  type="text"
                  autoComplete="address-level1"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="xip_code" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">
                ZIP / Postal code
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input
                  id="zip_code"
                  name="zip_code"
                  type="text"
                  autoComplete="postal-code"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-base/7 font-semibold text-gray-900">Notifications</h2>
          <p className="mt-1 max-w-2xl text-sm/6 text-gray-600">
            We'll only let you know about important changes, using the medium you choose.  We do not use your information for any other purpose. 
          </p>

          <div className="mt-10 space-y-10 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <fieldset>
              <legend className="sr-only">Push notifications</legend>
              <div className="sm:grid sm:grid-cols-3 sm:items-baseline sm:gap-4 sm:py-6">
                <div aria-hidden="true" className="text-sm/6 font-semibold text-gray-900">
                  How should we contact you? 
                </div>
                <div className="mt-1 sm:col-span-2 sm:mt-0">
                  <div className="max-w-lg">
                    <p className="text-sm/6 text-gray-600">We will only contact you with updates.</p>
                    <div className="mt-6 space-y-6">
                      <div className="flex items-center gap-x-3">
                        <input
                          defaultChecked
                          id="email"
                          name="contact_method"
                          type="radio"
                          className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
                        />
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                          Email
                        </label>
                      </div>
                      <div className="flex items-center gap-x-3">
                        <input
                          id="text"
                          name="contact_method"
                          type="radio"
                          className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
                        />
                        <label htmlFor="text" className="block text-sm/6 font-medium text-gray-900">
                          Text Message
                        </label>
                      </div>
                      <div className="flex items-center gap-x-3">
                        <input
                          id="both"
                          name="contact_method"
                          type="radio"
                          className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
                        />
                        <label htmlFor="both" className="block text-sm/6 font-medium text-gray-900">
                          Both
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div className="pb-32 px-10 flex items-center justify-end gap-x-6">
        <button type="button"  onClick={() => window.location.href = '/community'} className="text-sm/6 font-semibold text-gray-600 hover:text-gray-400">
          Cancel
        </button>
        <button
          type="submit"
          className="inline-flex justify-center rounded-md bg-gray-600  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Save
        </button>
      </div>
    </form>
    <Footer />
    </div>
  )
}